/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 空状态组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-12-11 11:00:00
 */

import React from 'react'
import { Button } from 'antd'
import './EmptyState.scss'

interface EmptyStateProps {
  onGoToAllPhotos: () => void
  isExtracting?: boolean
}

const EmptyState: React.FC<EmptyStateProps> = ({
  onGoToAllPhotos,
  isExtracting = false
}) => {
  return (
    <div className="emptyState">
      <div className="emptyText">没有可编辑照片，请添加照片</div>
      <Button type="primary" onClick={onGoToAllPhotos} disabled={isExtracting}>
        去添加照片
      </Button>
    </div>
  )
}

export default EmptyState
